export const BASE_API_URL = "https://api.workshopwithfriends.com"
export const BASE_ASSET_URL = "https://img.workshopwithfriends.com"
export const SMALL_PIC_SIZE = 600  // from 1/3 of max width (900) * 2 (for retina)
export const LARGE_PIC_SIZE = 1800 // max width (900) * 2 (for retina)